import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { VillageSelection } from './VillageSelection'
import { constants, getConnectUser, getStorage } from '../../helpers'
import { findPermission } from '../../helpers/findPermission'
import NoVillagePage from '../../components/noVillage'

export const Village = () => {
    const { t } = useTranslation()
    const { veVillages = [] } = getConnectUser()
    const navigate = useNavigate()
    const { search } = useLocation()

    const { USER_PERMISSIONS, VIEW_VILLAGES } = constants

    const userPermissions = getStorage(USER_PERMISSIONS)
    const canViewVillages = findPermission(userPermissions, VIEW_VILLAGES)

    const fromTab = parseInt((search || '').split('from_tab=')[1])

    useEffect(() => {
        if (!canViewVillages) {
            navigate('/')
        }
    }, [canViewVillages, navigate])

    useEffect(() => {
        if (veVillages?.length === 1) {
            const buildUrl = `/village/${veVillages[0]?.sf_id}${
                fromTab ? `?from_tab=${fromTab}` : ''
            }`
            navigate(buildUrl)
        }
    }, [veVillages, navigate, search])

    useEffect(() => {
        localStorage.setItem('scroll_pos', JSON.stringify({ scroll: 0 }))

        localStorage.setItem(
            'active_tab',
            JSON.stringify({ status: true, key: 0 })
        )

        document.title = t('village.pageTitle')
    }, [])

    const renderContent = () => {
        if (!veVillages || veVillages?.length <= 0) {
            return <NoVillagePage />
        }

        if (veVillages?.length > 1) {
            return <VillageSelection veVillages={veVillages} />
        }

        return null
    }

    return renderContent()
}
